module.exports = __webpack_public_path__ + "media/proksee-viewer/images/drag-handle-090ad4176be216ae31f91a792007acdd.png";